import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getUserGroups } from 'api/userGroups.service';
import { useToast } from 'hooks/ui';
import { IUserGroup } from 'models/userGroup.model';
import { userGroupsKeys } from './queryKeys';

interface UseUserGroupsGetQueryOptions {
  enabled?: boolean;
}

export const useUserGroupsGetQuery = ({
  enabled = true,
}: UseUserGroupsGetQueryOptions = {}) => {
  const toast = useToast();

  const query = useQuery({
    queryKey: userGroupsKeys.all,
    queryFn: (): Promise<Array<IUserGroup>> => getUserGroups(),
    enabled,
    refetchOnWindowFocus: false,
  });

  const { error } = query;

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error, toast]);

  return query;
};
